
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';
import EDFormControlLabel from '../../../../../../../BaseComponents/FormControlLabel/EDFormControlLabel';
import EDSwitch from '../../../../../../../BaseComponents/Switch/EDSwitch';
import { useBusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { FormUpdateAssociatonType } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { getRowsDeleteObjects } from '../../Utils/BokforderUtils';

interface IProps {
  editKontering: boolean;
  hasMadeChangesToKontering: boolean;
  setEditKontering: React.Dispatch<React.SetStateAction<boolean>>;
}

export const BokforderEditKonteringSwitch: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useBusinessDataFormContext();

  return (
    <EDBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        marginBottom: 0.5,
      }}
    >
      <EDFormControlLabel
        label="Redigera"
        control={
          <EDSwitch
            checked={props.editKontering}
            onChange={event => {
              const emptyRowsToRemove = getRowsDeleteObjects(
                formContext?.formState.currentValues,
                false,
                true
              );

              if (emptyRowsToRemove.length > 0) {
                const values: FormUpdateAssociatonType[][] = [];
                for (let index = 0; index < emptyRowsToRemove.length; index++) {
                  const elementToRemove = emptyRowsToRemove[index];

                  values.push(elementToRemove);
                }
                formContext?.update(values);
              }

              props.setEditKontering(event.target.checked);
            }}
            testId="redigera-kontering"
          />
        }
        disabled={props.editKontering && props.hasMadeChangesToKontering}
        disabledReason={
          props.editKontering && props.hasMadeChangesToKontering
            ? 'Du har ändrat kontering'
            : ''
        }
      />
    </EDBox>
  );
};
